import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./PrivacySettingsModal.css";

function PrivacySettingsModal({ isOpen, onClose }) {
  const [analyticsCookies, setAnalyticsCookies] = useState(false);
  const [advertisingCookies, setAdvertisingCookies] = useState(false);

  // Load preferences from localStorage on mount
  useEffect(() => {
    const savedAnalytics = localStorage.getItem("analyticsCookies");
    const savedAdvertising = localStorage.getItem("advertisingCookies");

    if (savedAnalytics !== null) {
      setAnalyticsCookies(savedAnalytics === "true");
    }
    if (savedAdvertising !== null) {
      setAdvertisingCookies(savedAdvertising === "true");
    }
  }, []);

  // Save preferences to localStorage when changed
  const handleAnalyticsChange = (e) => {
    const value = e.target.checked;
    setAnalyticsCookies(value);
    localStorage.setItem("analyticsCookies", value.toString());
  };

  const handleAdvertisingChange = (e) => {
    const value = e.target.checked;
    setAdvertisingCookies(value);
    localStorage.setItem("advertisingCookies", value.toString());
  };

  if (!isOpen) return null;

  return (
    <div className="privacy-modal-overlay" onClick={onClose}>
      <div className="privacy-modal" onClick={(e) => e.stopPropagation()}>
        <button className="privacy-modal-close" onClick={onClose}>
          ×
        </button>

        <h2 className="privacy-modal-title">Privacy Settings</h2>

        <p className="privacy-modal-notice">
          You are not logged in. Your preferences will only apply to this
          browser. To have your preferences synced, please log in.
        </p>

        <p className="privacy-modal-text">
          You can learn more about how we handle your data in our{" "}
          <Link to="/privacy" className="privacy-modal-link" onClick={onClose}>
            cookie policy
          </Link>
          . You can adjust your preferences below.
        </p>

        <div className="privacy-option">
          <label className="privacy-checkbox-container">
            <input
              type="checkbox"
              checked={analyticsCookies}
              onChange={handleAnalyticsChange}
              className="privacy-checkbox"
            />
            <span className="privacy-option-title">Analytics Cookies</span>
          </label>
          <p className="privacy-option-description">
            Help us understand which features are most useful to improve M31-V1.
          </p>
        </div>

        <div className="privacy-option">
          <label className="privacy-checkbox-container">
            <input
              type="checkbox"
              checked={advertisingCookies}
              onChange={handleAdvertisingChange}
              className="privacy-checkbox"
            />
            <span className="privacy-option-title">Advertising Cookies</span>
          </label>
          <p className="privacy-option-description">
            Help us understand which ads and referrals are most effective.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacySettingsModal;
